import React from 'react';
import './DegreeCard.css';
import Button from '../../../buttons/Button';
import { Fade, Flip } from 'react-reveal';

const DegreeCard = () => {
  return (
    <div className='degree-card'>
      <Flip left duration={2000}>
        <div className='card-img'>
          <img
            className='degree-pic'
            src={require('../../../../../img/ust-logo.png')}
            alt='lupet'
          />
        </div>
      </Flip>
      <Fade duration={2000} distance='40px'>
        <div className='card-body'>
          <div className='body-header'>
            <div className='body-header-title'>
              <h2 className='card-title'>University of Santo Tomas</h2>
              <h3 className='card-subtitle'>B.S. in Computer Science</h3>
            </div>
            <div className='body-header-duration'>
              <h3 className='duration'>2011-2016</h3>
            </div>
          </div>
          <div classname='body-content'>
            <p className='content-list'>
              <span role='img' aria-label='thunder'>
                ⚡
              </span>{' '}
              I studied Bachelor of Science in Computer Science in the
              prestigious school of the University of Santo Tomas. The school
              helped me hone my character as a person, and my skills as a
              programmer.
            </p>
            <a
              href='https://www.ust.edu.ph'
              target='_blank'
              rel='noopener noreferrer'
            >
              <div className='visit-btn'>
                <Button
                  style={{ marginTop: '0px' }}
                  text='Visit Website'
                  newTab={true}
                />
              </div>
            </a>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default DegreeCard;
